// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"783":"film-thickness","895":"tools"}[chunkId] + ".js";
};